import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  listImageModels,
  type ImageModelDto,
  type ImageModelMode,
} from '@api/processes';

const IMAGE_MODELS_KEY = ['image-models'] as const;

/**
 * Fetches the curated fal.ai image-model catalog for the Image Generation
 * node dropdown. {@code mode} switches between generate (text-to-image) and
 * edit (image-to-image) lists. The backend already caches per category, so a
 * long client staleTime just avoids redundant fetches while the editor is open.
 */
export function useImageModels(
  mode: ImageModelMode,
): UseQueryResult<readonly ImageModelDto[], Error> {
  return useQuery<readonly ImageModelDto[], Error>({
    queryKey: [...IMAGE_MODELS_KEY, mode],
    queryFn: () => listImageModels(mode),
    staleTime: 30 * 60_000,
    retry: 1,
  });
}
